import app from 'flarum/forum/app';
import Component from 'flarum/common/Component';
import Link from 'flarum/common/components/Link';
import classList from 'flarum/common/utils/classList';
import avatar from 'flarum/common/helpers/avatar';
import username from 'flarum/common/helpers/username';

export default class BlogArticleItem extends Component {
	oninit(vnode) {
		super.oninit(vnode);

		this.defaultImage = app.forum.attribute('blogDefaultImage')
			? `url(${
					app.forum.attribute('baseUrl') +
					'/assets/' +
					app.forum.attribute('blogDefaultImage')
			  })`
			: null;
	}

	getImage() {
		const { article } = this.attrs;

		return article.blogMeta()?.featuredImage?.()
			? `url(${article.blogMeta().featuredImage()})`
			: this.defaultImage;
	}

	view() {
		const { article } = this.attrs;

		const blogImage = this.getImage();
		return (
			<Link
				href={app.route('blogArticle', {
					id: `${article.slug()}`,
				})}
				className='BlogArticleItem'>
				<div
					class={classList('BlogArticleItem-image', {
						'FlarumBlog-default-image': blogImage === this.defaultImage,
					})}
					style={{ backgroundImage: blogImage }}
				/>

				<div class='BlogArticleItem-content'>
					<h3>{article.title()}</h3>
					<div class='BlogArticleItem-user'>
						{avatar(article.user())}
						{username(article.user())}
					</div>
				</div>
			</Link>
		);
	}
}
